import { Component } from '@angular/core';
import { ActionSheetController, AlertController, ModalController } from '@ionic/angular';
import { BasePage } from 'src/app/pages/basePage';
import { BodegaServices } from 'src/app/services/bodegaServices';
import { PickingServices } from 'src/app/services/pickingServices';

@Component({
  selector: 'app-picking-lote',
  templateUrl: './picking-lote.component.html',
  styleUrls: ['./picking-lote.component.scss'],
})
export class PickingLoteComponent extends BasePage{
  cantidad: number;
  seleccionandoBulto: boolean=false;
  current:any;
  bodegas: any[]=[];
  //bodegaDestino:any={name:'PROD2'}
  bodegaDestino:any={};
  constructor(ac:AlertController,private modalCtrl: ModalController, 
    private bodegaService:BodegaServices,public actionSheetController: ActionSheetController) { 
    super(ac);
    this.current=PickingServices.currentComponent;
    this.current.cantidadEnviada=0.0;
    
    if(this.current){
      if(this.current.BodegaOrigen=='MAT1' && this.esFranccionable())
        this.bodegaDestino={name: 'PSJ1'};
      else{
        if(this.current.BodegaDestino)
          this.bodegaDestino={name: this.current.BodegaDestino};
      }
      this.inicializarCantidadEnviada();
    }
    this.bodegas=bodegaService.getListadoBodegas();
  }
  inicializarCantidadEnviada(){
    if(this.current.ubicacionesSeleccionadas){
      this.current.ubicacionesSeleccionadas.forEach(u=>{
        this.current.cantidadEnviada+=u.cantidad;
      });
    }

  }
  seleccionarBulto(){
    this.seleccionandoBulto=true;
  }
  cantEnUbicacionCorrecta(ubicacion){
    for(let u of this.current.Ubicaciones){
      if(u.Ubicacion==ubicacion){
        if(this.current.cantidadUbicacion>u.Cantidad){
          this.show('La cantidad registrada en el ubicacición ('+u.Ubicacion+') es superior a la existente ('+u.Cantidad+')!!');
          return false;
        }
      }
    }
    return true;
  }
  async deseaBorrar(u) {
    if(!u)
      return;
    const actionSheet = await this.actionSheetController.create({
      header: 'Esta Seguro de borrar?',
      cssClass: 'my-custom-class',
      buttons: [{
        text: 'Borrar',
        role: 'destructive',
        icon: 'trash',
        handler: () => {
          const index=this.current.ubicacionesSeleccionadas.findIndex(us=>us.ubicacion==u.ubicacion)
          this.current.ubicacionesSeleccionadas.splice(index,1);
          this.current.cantidadEnviada-=u.cantidad;
        }
      }, {
        text: 'Cancel',
        icon: 'close',
        role: 'cancel',
        handler: () => {}
      }]
    });
    await actionSheet.present();
  }
  agregarBulto(){
    if(this.current.Lote!==this.current.loteSeleccionado){
      this.show("El lote seleccionado no corresponde con el solicitado")
      return;
    }
    if(!this.ubicacionCorrecta(this.current.ubicacionSeleccionada)){
      this.show("Debe pistolear la ubicación de origen ó el producto no se encuentra en la ubicación seleccionada!!")
      return false;
    }
    if(!this.current.cantidadUbicacion){
      this.show("Debe registrar la Cantidad de la ubicación seleccionada!!");
      return false;
    }
    if(!this.cantEnUbicacionCorrecta(this.current.ubicacionSeleccionada)){
      
      return false;
    }
    if(!this.current.ubicacionesSeleccionadas)
      this.current.ubicacionesSeleccionadas=[];
    let ubicacionYaRegistrada=false;
    this.current.ubicacionesSeleccionadas.forEach(u=>{
      if(u.ubicacion==this.current.ubicacionSeleccionada)
        ubicacionYaRegistrada=true
    });
    if(ubicacionYaRegistrada){
      this.show("El bulto de la ubicación "+this.current.ubicacionSeleccionada+" ya ha sido registrado");
      return;
    }
    if(this.current.cantidadEnviada>=this.current.Cantidad){
      this.show("No hace falta seleccionar mas bultos, actualmente ya tiene: "+this.current.cantidadEnviada)
      return;
    }
    this.current.ubicacionesSeleccionadas.push({
      lote: this.current.loteSeleccionado,
      ubicacion: this.current.ubicacionSeleccionada,
      cantidad: this.current.cantidadUbicacion
    });
    if(!this.current.cantidadEnviada)
      this.current.cantidadEnviada=0.0;
    this.current.cantidadEnviada+=this.current.cantidadUbicacion;
    this.encerarSeleccionBulto();
    console.log(this.current);
  }
  encerarSeleccionBulto(){
    this.seleccionandoBulto=false;
    this.current.ubicacionSeleccionada=null;
    this.current.loteSeleccionado=null;
    this.current.cantidadUbicacion=0;
  }
  cancelarSeleccionBulto(){
    this.encerarSeleccionBulto();
  }
  esFranccionable(){
    return (this.current.UnidadMedida && this.current.UnidadMedida.toLowerCase().includes('kg'));
  }
  onBodegaSelected(me){
    if(me && me.name)
      this.current.BodegaDestino=me.name;
  }
  onUbicacionSeleccionadaChange(e){
    console.log(e);
    console.log(this.current);
    this.setCantidadUbicacion();
  }
  setCantidadUbicacion(){
    if(this.current.Ubicaciones){
      for(let ubicacion of this.current.Ubicaciones){
        if(this.current.ubicacionSeleccionada==ubicacion.Ubicacion)
          this.current.cantidadUbicacion=ubicacion.Cantidad;
      };
    }
  }
  cancel() {
    console.log('cancel');
    console.log(this.current);
    this.encerar();
    return this.modalCtrl.dismiss(null, 'cancel');
  }
  encerar(){
    this.bodegaDestino=null;
    this.current={};
  }
  confirm() {
    console.log(this.current);
    if(this.valid())
      return this.modalCtrl.dismiss(this.current, 'confirm');
  }
  valid(){
    
    if(!this.current.BodegaDestino){
      this.show("Debe indicar la bodega destino!!")
      return false;
    }
    if(this.current.cantidadEnviada<this.current.CantidadReservada){
      this.show("La suma de las cantidades de los bultos ("+this.current.cantidadEnviada+") es menor a la requerida para este lote ("+this.current.CantidadReservada+")");
      return false;
    }
    return true;
  }
  ubicacionCorrecta(ubicacion){
    for(let u of this.current.Ubicaciones){
      if(u.Ubicacion==ubicacion)
        return true;
    }
    return false;
  }
}
